<div class="row" style="height: 188px">
  <div class="col">
    <p-autoComplete
      class="ao-dropdown indrop w-100"
      [(ngModel)]="selectedClient"
      [suggestions]="filteredClients"
      (completeMethod)="filterClients($event)"
      optionLabel="name"
      placeholder="Type to search for a client"
      [dropdown]="true"
      ariaLabel="Select Client"
      dropdownAriaLabel="Open Client list"
      autofocus
      appendTo="body"></p-autoComplete>
  </div>
</div>

<div class="row">
  <div class="col my-2">
    <div class="d-flex justify-content-end gap-2">
      <app-ao-button
        labelText="Cancel"
        [severity]="'secondary'"
        (buttonClick)="onCancel()"></app-ao-button>
      <app-ao-button
        labelText="Continue"
        [severity]="'success'"
        (buttonClick)="onSelect()"
        [disabled]="!selectedClient || isLoading"></app-ao-button>
    </div>
  </div>
</div>

<app-confirm-dialog
  #confirmDialog
  [header]="'Confirm Client Switch'"
  [message]="
    'Are you sure you want to switch to client ' +
    (selectedClient?.name || '') +
    '?'
  "
  acceptLabel="Yes"
  rejectLabel="No"
  (onConfirm)="onConfirm()">
</app-confirm-dialog>
